import {
    COMPARISONS_PRIORITY,
    EDIT_FIXTURES,
    EXTRA_MARKETS,
    GET_EVENT_MONEY_LINE_SUCCESS,
    GET_MARKET_CAP_SUCCESS,
    GET_SPORTS_SUCCESS,
    LIVE_MARKETS,
    MARKETS,
    PLAYER_MARKETS,
    SET_ALIVE,
    SET_BETFAIR_REFS,
    SET_BOOKMAKERS,
    SET_EVENT_MONEY_LINE,
    SET_FIXTURES,
    SET_MARKET_CAP
} from '../../constants/CommonConstants';
import {EDIT_MONITOR_EVENT, GET_EVENTS_SUCCESS} from '../../constants/MonitorConstants';
import {EDIT_EXTRA_EVENT, GET_EXTRA_EVENTS_SUCCESS} from '../../constants/ExtraConstants';
import {EDIT_LIVE_EVENT, GET_LIVE_EVENTS_SUCCESS} from '../../constants/LiveConstants';
import {LOGIN, LOGIN_SUCCESS, LOGOUT_SUCCESS} from '../../constants/LoginConstants';
import {AnyAction} from 'redux';
import {CommonReducer as State} from '../../@types/reducers';
import {CLIENT_IS_NOT_LOGGED_IN} from '../../constants/ErrorConstants';
import {GET_USER_INFO, GET_USER_INFO_ERROR, GET_USER_INFO_SUCCESS} from "../../constants/UserConstants";
import {
    BetfairRefsObject,
    BookmakerObject,
    EventsStoredObjects,
    EventStoredObject,
    MarketCapData,
    MarketCapObject,
    MoneyLineData,
    MoneyLineObject
} from "../../@types/response";
import {toEpochMs} from "../utils/commonUtils";
import {extractBetfairRefs} from "../utils/events";

const initialState: State = {
    bookmakers: {},
    comparisons: [],
    sports: {},
    client: undefined,
    eventBookmaker: [],
    getSessionChecked: false,
    markets: MARKETS,
    playerMarkets: PLAYER_MARKETS,
    extraMarkets: EXTRA_MARKETS,
    liveMarkets: LIVE_MARKETS,
    permissions: [],
    eventsMoneyLine: {},
    marketCap: {},
    betfairRefs: {},
    fixtures: {}
};

const commonReducer = (state = initialState, action: AnyAction): State => {
    switch (action.type) {
        case LOGIN_SUCCESS: {
            return {
                ...state,
                client: action.payload,
            };
        }
        case GET_USER_INFO: {
            return {
                ...state,
                getSessionChecked: initialState.getSessionChecked
            };
        }
        case GET_USER_INFO_SUCCESS: {
            return {
                ...state,
                client: action.payload ?? initialState.client,
                getSessionChecked: true,
            };
        }
        case GET_USER_INFO_ERROR: {
            return {
                ...state,
                client: initialState.client,
                getSessionChecked: true
            };
        }
        case SET_BOOKMAKERS: {
            const books: BookmakerObject[] = Object.values(action.payload)
            const comparisons: BookmakerObject[] = books
                .filter((b: BookmakerObject) => b.isComparison)
                .sort((a: BookmakerObject, b: BookmakerObject) => COMPARISONS_PRIORITY[a.id.toString()] - COMPARISONS_PRIORITY[b.id.toString()])
            const eventBookmaker = books.filter((item: BookmakerObject) => item.details >= 0)
                .sort((a: BookmakerObject, b: BookmakerObject) => {
                    if (a.details === b.details) {
                        return b.name > a.name ? -1 : 1
                    } else {
                        return b.details - a.details
                    }
                })
                .map((item: any) => item.id)
            return {
                ...state,
                bookmakers: action.payload,
                comparisons: comparisons,
                eventBookmaker: eventBookmaker
            };
        }
        case SET_FIXTURES: {
            return {
                ...state,
                fixtures: action.payload.reduce((acc: EventsStoredObjects, item: any) => {
                    const date = toEpochMs(item?.date);
                    acc[item._id] = {
                        ...(item as EventStoredObject),
                        date: (date ?? item?.date) as any,
                    };
                    return acc;
                }, {})
            }
        }
        case EDIT_FIXTURES: {
            const date = toEpochMs(action.payload?.fixture?.date);
            return {
                ...state,
                fixtures: {
                    ...state.fixtures,
                    [action.payload.fixture._id]: {
                        ...(action.payload.fixture as EventStoredObject),
                        date: (date ?? action.payload?.fixture?.date) as any,
                    }
                }
            }
        }
        case GET_SPORTS_SUCCESS: {
            return {
                ...state,
                sports: action.payload
            };
        }
        /*resetting*/
        case LOGIN:
        case LOGOUT_SUCCESS: {
            return {
                ...state,
                client: initialState.client,
                permissions: initialState.permissions
            };
        }
        case CLIENT_IS_NOT_LOGGED_IN:
            return {
                ...state,
                client: initialState.client,
                permissions: initialState.permissions,
            };
        case SET_ALIVE:
            let bookmaker: BookmakerObject = Object.assign({}, state.bookmakers[action.payload.bookmaker])
            const productId: string = action.payload.product
            if (productId && bookmaker.products) {
                bookmaker['products'][productId] = action.payload.alive
            }
            return {
                ...state,
                bookmakers: Object.assign({}, state.bookmakers, {[action.payload.bookmaker]: bookmaker}),
            };
        case GET_EVENT_MONEY_LINE_SUCCESS: {
            return {
                ...state,
                eventsMoneyLine: action.payload
            };
        }
        case SET_EVENT_MONEY_LINE: {
            const update = action.payload.reduce((a: MoneyLineObject, v: MoneyLineData) => ({...a, [v.k]: v}), {})
            return {
                ...state,
                eventsMoneyLine: Object.assign({}, state.eventsMoneyLine, update)
            };
        }
        case GET_MARKET_CAP_SUCCESS: {
            return {
                ...state,
                marketCap: action.payload
            }
        }
        case SET_MARKET_CAP: {
            const update = action.payload.reduce((a: MarketCapObject, v: MarketCapData) => ({...a, [v.k]: v}), {})
            return {
                ...state,
                marketCap: Object.assign({}, state.marketCap, update)
            }
        }
        // Extract betfair refs from section event payloads
        case GET_EVENTS_SUCCESS: {
            const refs: BetfairRefsObject = {}
            for (const e of action.payload.events ?? []) {
                const r = extractBetfairRefs(e)
                if (r) refs[e._id] = r
            }
            return {...state, betfairRefs: {...state.betfairRefs, ...refs}}
        }
        case GET_EXTRA_EVENTS_SUCCESS:
        case GET_LIVE_EVENTS_SUCCESS: {
            const refs: BetfairRefsObject = {}
            for (const e of action.payload ?? []) {
                const r = extractBetfairRefs(e)
                if (r) refs[e._id] = r
            }
            return {...state, betfairRefs: {...state.betfairRefs, ...refs}}
        }
        case EDIT_MONITOR_EVENT:
        case EDIT_EXTRA_EVENT:
        case EDIT_LIVE_EVENT: {
            const event = action.payload.event ?? action.payload
            const r = extractBetfairRefs(event)
            if (!r) return state
            return {...state, betfairRefs: {...state.betfairRefs, [event._id]: r}}
        }
        case SET_BETFAIR_REFS: {
            const event = action.payload
            const id = event?._id ?? event?.id
            if (!id) return state
            const r = extractBetfairRefs(event)
            if (!r) return state
            return {...state, betfairRefs: {...state.betfairRefs, [id]: r}}
        }
        default:
            return state;
    }
};

export default commonReducer;
